import { useRelativeDrag } from 'lib/events-framework/useRelativeDrag'
import React, { FC } from 'react'
import styled, { StyledComponent } from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'

type Props = {
  offsetLeft: number
  onOffsetLeftChange: (offset: number) => void
  type: 'left' | 'right' | 'single'
  onDrop?: () => void
  onPick?: () => void
}

export const SliderHandle: FC<Props> = ({ offsetLeft, onOffsetLeftChange, type, onDrop = () => {}, onPick }) => {
  const { pick, picked } = useRelativeDrag({
    position: [offsetLeft, 0],
    onPositionChange: ([x, y]) => {
      onOffsetLeftChange(x)
    },
    onDrop
  })

  let Component: typeof LeftHandle | typeof RightHandle | typeof Handle
  if (type === 'left') {
    Component = LeftHandle
  } else if (type === 'right') {
    Component = RightHandle
  } else {
    Component = Handle
  }

  return (
    <Component
      onPointerDown={(e) => {
        pick(e)
        onPick && onPick()
      }}
      picked={picked}
      style={{
        transform: `translateX(${offsetLeft}px)`
      }}
    />
  )
}

const Handle = styled.div<{ picked: boolean }>`
  z-index: 1;
  user-select: none;
  touch-action: none;
  position: absolute;
  width: ${({ theme }) => theme.spacing[4]};
  height: ${({ theme }) => theme.spacing[6]};
  top: ${({ theme }) => '-0.6rem'};
  color: ${({ theme, picked }) => (picked ? theme.palette.brand.secondary : theme.palette.brand.primary)};
  color: ${({ theme, picked }) => {
    if (getProjectName() === 'generic_v2') return '#828282'
    return getProjectName() === 'amber' && (picked ? theme.palette.grey[200] : theme.palette.brand.primary)
  }};
  cursor: pointer;

  &:before {
    margin-top: ${({ theme }) => theme.spacing[1]};

    content: '';
    position: absolute;
    background: currentColor;
    width: ${({ theme }) => theme.spacing[4]};
    height: ${({ theme }) => theme.spacing[4]};
    border-radius: ${() => {
      if (getProjectName() === 'generic_v2') return '0.8rem'
      return '0.3rem 0.3rem 0.3rem 0.3rem'
    }};
  }
`

const LeftHandle = styled(Handle)`
  margin-left: ${({ theme }) => -theme.spacing[2]};
  &:before {
    border-radius: ${() => {
      if (getProjectName() === 'generic_v2') return '0.8rem'
      return getProjectName() === 'avito' ? '50%' : '0.3rem 0 0 0.3rem'
    }};
  }
`

const RightHandle = styled(Handle)`
  margin-left: ${({ theme }) => theme.spacing[2]};
  &:before {
    border-radius: ${() => {
      if (getProjectName() === 'generic_v2') return '0.8rem'
      if (getProjectName() === 'avito') return '50%'
      return '0 0.3rem 0.3rem 0'
    }};
  }
`
